import { Button } from "Components/Button";

import { SelectScheduleContainer } from "Pages/SchedulePartner/styles";
import { DateTime } from "Components/Cards/DateTime";

import { Loader } from "Components/Loader";
import { Box } from "styles/globalComponents";
import { MonthsOptions } from "Components/MonthsOptions";
import { useSelectCalendar } from "../useSelectCalendarId";

export const SelectCalendar = () => {
  const {
    availableDates,
    dateRequest,
    setDateRequest,
    capitilizedMonth,
    appointment,
    availableHours,
    handleSelectCalendar,
    handleSelectHour,
    createSchedule,
    loadingCreation,
    setAppointmentInfo,
  } = useSelectCalendar();

  const error = availableDates?.error as any;

  return (
    <SelectScheduleContainer>
      <h2 className="text-center text-centered text-purple section-title">
        Selecione data e horário para o agendamento.
      </h2>

      <div className="schedule-sec">
        <div className="available-months">
          <p className="text-center text-purple schedule-searching text-md">
            Próximos meses
          </p>
          <MonthsOptions
            selectedMonth={dateRequest}
            setRequestMonth={setDateRequest}
            blockedClick={!availableDates.isSuccess}
            setAppointmentInfo={setAppointmentInfo}
          />
        </div>

        {availableDates?.data?.length === 0 && (
          <div className="available-months">
            <p className="text-center text-purple schedule-searching text-md">
              Ainda não há data disponível para o mês selecionado
            </p>
          </div>
        )}

        {availableDates.isError && (
          <p className="text-center text-centered text-purple schedule-searching text-md error">
            {" "}
            {error?.response?.data?.error as string}
          </p>
        )}

        {availableDates.isLoading ? (
          <Box display="flex" justify="center" mt="40">
            <Loader />
          </Box>
        ) : null}

        {availableDates?.data?.length >= 1 && (
          <div className="datetime-result-list">
            <p className="text-center text-purple schedule-searching text-md">
              Datas disponíveis em {capitilizedMonth}
            </p>

            <div className="container-dates-options">
              <div className="dates-list">
                {availableDates?.data?.map((date: any) => (
                  <DateTime
                    dateTimeInfo={date}
                    key={date.date}
                    onSelectDate={handleSelectCalendar}
                    selectedDateTime={appointment.query_date}
                  />
                ))}
              </div>
            </div>

            {availableHours.isLoading ? (
              <Box display="flex" justify="center" mt="40">
                <Loader />
              </Box>
            ) : null}

            {availableHours?.data?.length > 1 && (
              <div className="container-times-options">
                <p className="text-center text-purple schedule-searching text-md">
                  Horários disponíveis
                </p>
                <div className="dates-list">
                  {availableHours?.data?.map((time: any) => (
                    <DateTime
                      dateTimeInfo={time}
                      key={time.time}
                      onSelectDate={handleSelectHour}
                      selectedDateTime={appointment.query_hour}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {appointment.query_hour && availableHours?.data?.length && (
          <Box mt="20" display="flex" justify="center">
            <Button
              onClick={createSchedule}
              disabled={loadingCreation}
              loading={loadingCreation}
            >
              Agendar
            </Button>
          </Box>
        )}
      </div>
    </SelectScheduleContainer>
  );
};
